/* ── A briefing field that SHOULD be a list, guaranteed to be one ──────────
   The model returns the briefing through a forced tool call, and on
   2026-08-25 it put a JSON STRING where six arrays belonged:

     recommendations: "{\"recommendations\":[{\"rank\":1,…}]}"

   …and the same for chips, coaching, etaPredictions, fuelAnomalies and
   maintenance. A string is TRUTHY, so every `(brief.x || [])` guard in the app
   sailed straight past it and then called `.find` / `.slice().forEach` on a
   string. With no error boundary in the app, React unmounted the whole tree
   and trasseapp.com/fleet went white.

   provider.js now coerces at the model boundary, so bad documents stop being
   written. This stops one that ALREADY exists — or any future shape nobody
   predicted — from taking a page down merely for reading it.

   Lives in utils/ rather than briefingsApi so zanaLocalAsk can use it too:
   briefingsApi imports zanaLocalAsk, so the reverse would be circular. */
export function asList<T>(value: unknown): T[] {
  return Array.isArray(value) ? (value as T[]) : [];
}
